const RANK_STYLES = {
  legendary: { color: "#FF9ED2", glow: "rgba(255, 95, 180, 0.5)", label: "#1" },
  diamond:   { color: "#8AECFF", glow: "rgba(80, 220, 255, 0.5)", label: "TOP 3" },
  gold:      { color: "#FFD873", glow: "rgba(255, 195, 60, 0.5)", label: "TOP 5" },
  silver:    { color: "#DFE9EF", glow: "rgba(180, 210, 230, 0.4)", label: "TOP 10" },
  bronze:    { color: "#E7B57F", glow: "rgba(180, 120, 60, 0.4)", label: "RANKED" },
};

export function RankChip({ rankLabel, rank, size = "md" }) {
  const s = RANK_STYLES[rankLabel] || RANK_STYLES.bronze;
  const isSm = size === "sm";
  return (
    <div
      className={`inline-flex items-center gap-1.5 ${isSm ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]"} font-mono uppercase tracking-widest`}
      style={{
        color: s.color,
        border: `1px solid ${s.color}66`,
        background: `linear-gradient(90deg, ${s.glow} 0%, transparent 100%)`,
        clipPath: "polygon(6px 0, 100% 0, calc(100% - 6px) 100%, 0 100%)",
      }}
      data-testid={`rank-chip-${rankLabel}`}
    >
      {rank ? `#${rank}` : s.label}
      <span className="opacity-70">·</span>
      <span>{rankLabel}</span>
    </div>
  );
}
